import KeycloakJS from 'keycloak-js'

const Keycloak = KeycloakJS('/keycloak.json')
export default Keycloak
